import { createContext } from "react";

import { ScheduleScreenHelper } from "./ScheduleScreenHelper.ts";

// Empty object is provided as default context as unable to create a CommsScheduleScreenHelper class without a RootStore
// This will result in the app or tests breaking if a context value isn't provided
export const ScheduleScreenContext = createContext<ScheduleScreenHelper>(
  {} as ScheduleScreenHelper
);
